import { render, staticRenderFns } from "./VideoAnalyse.vue?vue&type=template&id=4022087c&"
import script from "./VideoAnalyse.vue?vue&type=script&lang=js&"
export * from "./VideoAnalyse.vue?vue&type=script&lang=js&"
import style0 from "./VideoAnalyse.vue?vue&type=style&index=0&id=4022087c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports